import { render, staticRenderFns } from "./sticky_test.vue?vue&type=template&id=2904700d&scoped=true"
import script from "./sticky_test.vue?vue&type=script&lang=js"
export * from "./sticky_test.vue?vue&type=script&lang=js"
import style0 from "./sticky_test.vue?vue&type=style&index=0&id=2904700d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904700d",
  null
  
)

export default component.exports